import React, { Component } from "react";
import MainContent2 from "../Components/MainContent/MainContent2";
import SocialContent from "../Components/SocialContent/SocialContent";
import AboutContent from "../Components/AboutContent/AboutContent";
import ContactContent from "../Components/ContactConent/ContactContent";
import Footer from "../Components/Footer/Footer";
import Hero from "../Components/Hero/Hero";
import Header from "../Components/Header/Header";
import HeroButtons2 from "../Components/Hero/HeroButtons2";

export default class Main extends Component {
  render() {
    return (
      <div>
        <Header colour={"3"} showLinks={true} />
        <Hero colour={"3"} text="Hyper... Coming to an OB near you" />
        <HeroButtons2 />
        <MainContent2 />
        <div className="LowerSection">
          <div className="Content">
            <AboutContent />
          </div>
        </div>
        <SocialContent altColour={false} />
        <div className="LowerSection Social">
          <div className="Content">
            <ContactContent />
          </div>
        </div>
        <Footer altColour={true} />
      </div>
    );
  }
}
